interface TypeFilterProps {
  currentType: 'all' | 'likes' | 'bookmarks';
  onChange: (type: 'all' | 'likes' | 'bookmarks') => void;
}

export function TypeFilter({ currentType, onChange }: TypeFilterProps) {
  const types = [
    { value: 'all' as const, label: '全部' },
    { value: 'likes' as const, label: '点赞' },
    { value: 'bookmarks' as const, label: '收藏' },
  ];

  return (
    <div className="filter-group mb-4">
      <label className="block text-text-secondary text-xs font-semibold mb-2">类型筛选</label>
      <div className="filter-buttons flex gap-2 flex-wrap">
        {types.map((type) => (
          <button
            key={type.value}
            className={`filter-btn px-4 py-2 rounded-lg text-sm transition-all ${
              currentType === type.value
                ? 'bg-accent border-accent text-white'
                : 'bg-bg-tertiary border-border text-text-secondary hover:bg-border'
            } border`}
            onClick={() => onChange(type.value)}
          >
            {type.label}
          </button>
        ))}
      </div>
    </div>
  );
}
